import React, { createContext, useContext, useState } from 'react';

const GeoJsonDataContext = createContext();

/**
 * Reads { geoJsonData, setGeoJsonData, loadError, setLoadError } from the
 * nearest GeoJsonDataProvider. geoJsonData is null until DataLoaderHelper's
 * fetch/transform completes, and loadError is null unless that load failed —
 * consumers must treat "null data" and "load failed" as different states, or
 * a failed fetch shows an endless spinner.
 * Must be called within a GeoJsonDataProvider.
 */
export const useGeoJsonData = () => {
  const context = useContext(GeoJsonDataContext);
  if (context === undefined) {
    throw new Error('useGeoJsonData must be used within a GeoJsonDataProvider');
  }
  return context;
};

/**
 * Holds the single geoJsonData value shared by Map and Table, populated
 * once by DataLoaderHelper after it fetches and transforms the submission
 * CSVs into a GeoJSON FeatureCollection. loadError carries the failure if
 * that never happens.
 */
export const GeoJsonDataProvider = ({ children }) => {
  const [geoJsonData, setGeoJsonData] = useState(null);
  const [loadError, setLoadError] = useState(null);

  return (
    <GeoJsonDataContext.Provider
      value={{ geoJsonData, setGeoJsonData, loadError, setLoadError }}
    >
      {children}
    </GeoJsonDataContext.Provider>
  );
};
